<template>
  <div class="row" style="height: 200px;">
    <div class="col-md">
      <!-- <div class="row">
        <div class="col">
          <DropSelect
            :z-index="4"
            v-bind="selectType"
            v-model="selectType.selected"
          />
        </div>
      </div> -->
      <div class="row">
        <div class="col">
          <!-- <DropSelect
            :z-index="3"
            v-bind="selectStudent"
            v-model="selectStudent.selected"
            v-if="selectType.selected == 1"
          /> -->
          <DropSelect
            :z-index="3"
            v-bind="selectCourse"
            v-model="selectCourse.selected"
            @selected="addingCourse"
          />
          <!-- v-if="selectType.selected == 2" -->
          <!-- <DropSelect
            :z-index="3"
            v-bind="selectLevel"
            v-model="selectLevel.selected"
            v-if="selectType.selected == 3"
          /> -->
        </div>
      </div>
      <div class="row">
        <div
          class="col-auto"
          v-for="(item, index) of selectedCourses"
          :key="index"
        >
          <Chips :item="item"></Chips>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col text-center">
          <button @click="show" class="button secondary">
            Descargar
          </button>
        </div>
      </div>
    </div>
    <!-- <div class="col-md-6">
      <img src="@/assets/images/kalak-12.png" />
    </div> -->
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import DropSelect from "@/components/DropSelect";
import Chips from "@/components/Chips";

export default {
  name: "DownloadMonthlyReportsView",
  components: {
    DropSelect,
    Chips,
  },
  computed: {
    ...mapState([
      "teacherData",
      "userData",
      "dataUrl",
      "courseList",
      "showR",
      "selectedCourses",
    ]),
  },
  data() {
    let { secCol, grayCol } = this.$store.getters;

    return {
      secCol,
      grayCol,
      initialDate: null,
      endDate: null,
      selectType: {
        id: "type",
        supTitle: "Tipo de reporte",
        placeholder: "Seleccione el reporte",
        selected: null,
        icon: "file",
        options: [
          {
            text: "Por alumno",
            value: 1,
          },
          {
            text: "Por curso",
            value: 2,
          },
          {
            text: "Por nivel",
            value: 3,
          },
        ],
      },
      selectStudent: {
        id: "student",
        supTitle: "Alumno",
        placeholder: "Seleccione alumno",
        selected: null,
        icon: "book-reader",
        options: [
          {
            text: "Alumno 1",
            value: 1,
          },
          {
            text: "Alumno 2",
            value: 2,
          },
          {
            text: "Alumno 3",
            value: 3,
          },
        ],
      },
      selectCourse: {
        options: [],
        selected: null,
        placeholder: "Seleccione Curso para generar reporte",
        supTitle: "Cursos",
        id: "reports",
        icon: "graduation-hat",
        valueKey: "id",
        textKey: "name",
      },
      selectLevel: {
        id: "level",
        supTitle: "Nivel",
        placeholder: "Seleccione nivel",
        selected: null,
        icon: "signal",
        options: [
          {
            text: "Nivel 1",
            value: 1,
          },
          {
            text: "Nivel 2",
            value: 2,
          },
          {
            text: "Nivel 3",
            value: 3,
          },
        ],
      },
    };
  },
  watch: {
    initialDate(newVal, oldVal) {
      if (!newVal) return;
      if (newVal == oldVal) return;

      if (this.endDate) {
        let initialDate = new Date(newVal);
        let endDate = new Date(this.endDate);

        if (endDate <= initialDate) {
          this.$notify({
            title: [
              "Fecha incorrecta",
              "La fecha inicial no puede ser mayor a la fecha final",
            ],
            type: "danger",
          });
          this.initialDate = oldVal;
          return;
        }
      }
    },
    endDate(newVal, oldVal) {
      if (!newVal) return;
      if (newVal == oldVal) return;

      if (this.initialDate) {
        let initialDate = new Date(this.initialDate);
        let endDate = new Date(newVal);

        if (endDate <= initialDate) {
          this.$notify({
            title: [
              "Fecha incorrecta",
              "La fecha final no puede ser menor a la fecha inicial",
            ],
            type: "danger",
          });
          this.endDate = oldVal;
          return;
        }
      }
    },
    "userData.pendingReportDTO.pendingReports"(newValue) {
      this.selectCourse.options = this.selectCourse.options.filter(item =>
        newValue.some(itemP => itemP.id === item.id)
      );
    },
  },
  methods: {
    ...mapActions(["setShowR", "addCourse"]),
    getCourses() {
      this.selectCourse.options = this.userData.pendingReportDTO.pendingReports;
      if (this.selectedCourses.length === 0) {
        this.addCourse(this.userData.pendingReportDTO.pendingReports[0]);
      }
    },
    show() {
      window.scrollTo(0, 0);
      this.setShowR({ value: true, isPendingReport: true });
    },
    addingCourse(selected) {
      let pass = false;
      if (this.selectedCourses.length) {
        pass = this.selectedCourses.some(
          element => element.id === selected.value
        );
      }

      if (!pass) {
        let sel = this.userData.pendingReportDTO.pendingReports.filter(el => {
          return el.id == selected.value;
        });
        if (sel.length) this.addCourse(sel[0]);
      }
    },
  },
  mounted() {
    this.getCourses();
  },
};
</script>
